<template>
  <div class="main">
    <div class="mian-top">
      <div @click="back">
        <i class="el-icon-arrow-left"></i>
        返回
      </div>
    </div>
    <div class="mian-bottom">
      <div>
        <div class="bottitle">确认订单信息</div>
        <div class="table">
          <div class="props">套餐类型</div>
          <div class="props">人数</div>
          <div class="props">条数</div>
          <div class="props">单价</div>
          <div class="props">数量</div>
          <div class="props">合计</div>
        </div>
        <div class="tableitem">
          <div class="props">
            <el-select v-model="packagename" placeholder="请选择套餐" @change="packagechange">
              <el-option v-for="item in mergepackage" :key="item[0].packageName" :label="item[0].packageName" :value="item[0].packageName">
              </el-option>
            </el-select>
          </div>
          <div class="props">
            <el-select v-model="person" placeholder="请选择适用人数" @change="personchange">
              <el-option v-for="item in checkpackage" :key="item.id" :label="`${item.lowerLimit}(含)-${item.upperLimit}人`" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="props">{{ packageinfo.num }}条</div>
          <div class="props">
            {{ packageinfo.price * packageinfo.preferentialPrice }}元/年
          </div>
          <div class="props">
            <el-select v-model="num" placeholder="请选择" @change="numchange">
              <el-option 
              v-for="item in Discountlist" 
              :key="item.buyCount" 
              :label="`${item.buyCount}年${transformtime(item.startDate, item.endDate)? transformdiscount(item.discount): ''}`"  
              :value="item.buyCount">
              </el-option>
            </el-select>
          </div>
          <div class="props" style="color: #ea4f2c">
            ￥{{
              (
                packageinfo.price *
                packageinfo.preferentialPrice *
                numchecked.buyCount *
                (transformtime(numchecked.startDate, numchecked.endDate)
                  ? numchecked.discount
                  : 1)
              ).toFixed(2)
            }}元
          </div>
        </div>
      </div>
      <div class="xieyi">
        <el-checkbox v-model="xieyiflag"></el-checkbox>
        <span class="xieyitxt">
          我已阅读并同意 <span @click="readxieyi">《工资条服务协议》</span>
        </span>
      </div>
      <!-- <div class="paybtn" @click="upgradepayment" v-if="isupgrade">立即支付</div> -->
      <div class="paybtn" @click="payment">确认支付</div>
    </div>

    <!-- 用户协议 -->
    <el-dialog :visible.sync="checkVisible" :close-on-click-modal="false">
      <div class="reg-text" v-html="content"></div>
      <div style="text-align: center; margin-top: 20px">
        <el-button type="primary" @click="onArgeen" style="width: 350px" round>同 意</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  packagesalary,
  createorder,
  getPreferentialList,
  upgradepackage,
} from '@/api/setUp.js'
export default {
  props: ['isupgrade', 'checkedpackage', 'upgradeinfo', 'content'],
  created () {
    // this.getpackage()
    this.packagename = this.checkedpackage
    this.getpackagelist()
    this.getDiscount()
  },
  data () {
    return {
      packagename: '', //选择套餐的名称
      mergepackage: [], //套餐按名称合并之后的集合
      checkpackage: [], //按套餐名称检索之后的集合
      person: '', //选择适用人数 所对应具体的套餐id
      packageinfo: [],
      Discountlist: [],
      num: 1,
      numchecked: {},
      xieyiflag: true,
      checkVisible: false,
    }
  },
  methods: {
    readxieyi () {
      this.checkVisible = true
    },
    onArgeen () {
      this.xieyiflag = true
      this.checkVisible = false
    },
    // 获取所有套餐并且合并
    async getpackagelist () {
      let { data } = await packagesalary({ app: 'salary' })
      console.log(data)
      // 获取所有套餐名称
      let Nopackagename = []
      data.forEach((item) => {
        Nopackagename.push(item.packageName)
      })
      console.log(Nopackagename, '套餐名称')

      Nopackagename = Array.from(new Set(Nopackagename)) //套餐名称去重
      // packagename = Array.from(new Set(packagename)) //套餐名称去重
      console.log(Nopackagename, '套餐名称去重')
      let packagename = []

      Nopackagename.forEach((item) => {
        if (item != '免费版') {
          packagename.push(item)
        }
      })
      console.log(packagename, '去除免费版')
      // packagename = packagename.slice(1, packagename.length - 1) //购买套餐选择去掉第一个（）

      // 根据套餐名称将相同名称的套餐合并
      let mergepackage = []
      packagename.forEach((item1) => {
        let packageitem = []
        data.forEach((item) => {
          if (item.packageName == item1) {
            packageitem.push(item)
          }
        })
        mergepackage.push(packageitem)
      })
      this.mergepackage = mergepackage
      console.log(this.mergepackage, '套餐按名字分组之后')
      this.packagechange()
    },

    // 购买套餐 选择套餐
    packagechange (val) {
      if (val == '私有定制') {
        this.$emit('dialogclose', true)
        return 0
      }
      // console.log(val)
      let checked = this.mergepackage.filter((item) => {
        return item[0].packageName == this.packagename
      })
      console.log(checked, 'c1')
      this.checkpackage = checked[0]
      this.person = this.checkpackage[0].id
      this.personchange()
    },

    personchange (val) {
      let checked = this.checkpackage.filter((item) => {
        return item.id == this.person
      })
      this.packageinfo = checked[0]
      console.log('cccc', this.packageinfo)
    },

    // 获取折扣列表
    async getDiscount () {
      let { data } = await getPreferentialList()
      this.Discountlist = data
      this.num = this.Discountlist[0].buyCount
      this.numchange()
    },
    numchange (val) {
      let data = this.Discountlist.filter((item) => {
        return item.buyCount == this.num
      })
      this.numchecked = data[0]
    },

    transformdiscount (val) {
      if(val < 1 && val > 0){
        let _num =Number(val)*10
        return `${_num}折`
      }else{
       return '';
      }
      // if (val == 1) {
      //   return ''
      // } else if (val == 0.9) {
      //   return '（9折）'
      // } else if (val == 0.8) {
      //   return '（8折）'
      // } else if (val == 0.7) {
      //   return '（7折）'
      // } else if (val == 0.6) {
      //   return '（6折）'
      // } else if (val == 0.5) {
      //   return '（5折）'
      // } else if (val == 0.4) {
      //   return '（4折）'
      // } else if (val == 0.3) {
      //   return '（3折）'
      // } else if (val == 0.2) {
      //   return '（2折）'
      // } else if (val == 0.1) {
      //   return '（1折）'
      // }
    },
    transformyear (val) {
      if (val == 1) {
        return '一年'
      } else if (val == 2) {
        return '两年'
      } else if (val == 3) {
        return '三年'
      } else if (val == 4) {
        return '四年'
      } else if (val == 5) {
        return '五年'
      } else if (val == 6) {
        return '六年'
      } else if (val == 7) {
        return '七年'
      } else if (val == 8) {
        return '八年'
      } else if (val == 9) {
        return '九年'
      } else if (val == 10) {
        return '十年'
      }
    },
    // 生成订单 选择支付方式

    transformtime (start, end) {
      let nowdate = new Date().valueOf()
      if (start <= nowdate && nowdate <= end) {
        return true
      } else {
        return false
      }
    },

    async payment () {
      if (this.xieyiflag) {
        let { data } = await createorder({
          packageId: this.person,
          orderNum: this.num,
        })
        let person = `${this.packageinfo.lowerLimit}-${this.packageinfo.upperLimit}`
        let num = this.packageinfo.num
        let buynum = this.num
        let totle = (
          this.packageinfo.price *
          this.packageinfo.preferentialPrice *
          this.numchecked.buyCount *
          (this.transformtime(
            this.numchecked.startDate,
            this.numchecked.endDate
          )
            ? this.numchecked.discount
            : 1)
        ).toFixed(2)
        this.$router.push(
          `/index/chosePayment?total=${totle}&orderNum=${data.data}&name=${this.packagename}&person=${person}&num=${num}&buynum=${buynum}`
        )
      } else {
        this.$message({
          type: 'warning',
          message: '请先同意购买须知',
        })
      }
    },
    back () {
      this.$emit('itemclick', 1)
    },
  },
  watch: {
    packagename: {
      handler (newVal, oldVal) {
        if (newVal == '私有定制') {
          this.packagename = oldVal
        }
      },
    },
  },
}
</script>

<style lang="less" scoped>
.main {
  padding: 10px;
  .mian-top {
    height: 57px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: left;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2c2d3a;
    line-height: 22px;
    padding-left: 14px;
    div {
      cursor: pointer;
    }
  }
  .mian-bottom {
    height: calc(100vh - 150px);
    background: #ffffff;
    border-radius: 8px;
    margin-top: 10px;
    padding: 15px ;
    .bottitle {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #2c2d3a;
      line-height: 28px;
      margin-bottom: 16px;
    }
    .table {
      height: 56px;
      background: rgba(59, 196, 146, 0.1);
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .props {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 550;
        color: rgba(0, 0, 0, 0.7);
        line-height: 20px;
        width: 20%;
        text-align: center;
      }
    }
    .tableitem {
      height: 56px;
      margin: 0 auto;
      background: #ffffff;
      box-shadow: inset 0px -1px 0px 0px #dfe5eb;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .props {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2c2d3a;
        line-height: 20px;
        width: 20%;
        text-align: center;
      }
    }
    .buymode {
      width: 55%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .modeitem {
        width: 224px;
        height: 56px;
        background: rgba(83, 203, 159, 0);
        border-radius: 4px;
        border: 1px solid #e0eaf1;
        display: flex;
        align-items: center;
        justify-content: left;
        img {
          height: 40px;
          width: 40px;
          margin: 0 8px;
        }

        .moderight {
          .paytitle {
            font-size: 10px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #2c2d3a;
            line-height: 14px;
          }
          .payinfo {
            font-size: 8px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #838f99;
            line-height: 11px;
          }
        }
      }
    }
    .xieyi {
      margin: 15px 0 ;
    }
    .paybtn {
      width: 200px;
      height: 40px;
      background: #3bc492;
      border-radius: 20px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }
  }
}
.xieyitxt {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #6f7276;
  line-height: 20px;
  span {
    color: #2f7ff8;
    cursor: pointer;
  }
}
.reg-text {
  height: 60vh;
  overflow: auto;
}
</style>
